import { createTheme } from '@mui/material/styles';

// Color palette
export const primary = '#337AB7';
export const secondary = '#33B7B3';
export const accent = '#EDA05F';
export const error = '#C7403E';
export const warning = '#FFB559';
export const info = '#337AB7';
export const success = '#398256';
export const black = '#000';
export const tuna = '#36383B';
export const silver = '#CCCCCC';
export const white = '#fff';
export const bitpix = '#54a936';

// Extend the MUI theme
declare module '@mui/material/styles' {
  interface Palette {
    bitpix: Palette['primary'];
    accent: Palette['primary'];
    muted: Palette['primary'];
  }
  interface PaletteOptions {
    bitpix?: PaletteOptions['primary'];
    accent?: PaletteOptions['primary'];
    muted?: PaletteOptions['primary'];
  }
}

const Theme = createTheme({
  palette: {
    bitpix: {
      main: bitpix,
      contrastText: white,
    },
    primary: {
      main: primary,
      contrastText: white,
    },
    secondary: {
      main: secondary,
      contrastText: black,
    },
    accent: {
      main: accent,
      contrastText: black,
    },
    error: {
      main: error,
      contrastText: white,
    },
    warning: {
      main: warning,
      contrastText: black,
    },
    info: {
      main: info,
      contrastText: white,
    },
    success: {
      main: success,
      contrastText: white,
    },
    muted: {
      main: tuna,
      contrastText: white,
    },
    tonalOffset: 0.2,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default Theme;
